export default __webpack_public_path__ + "static/media/deadtree.12f8df78.png";